<template>
  <div id="recos-page">
    <Recos />
  </div>
</template>

<script>
import Recos from '../components/Recos.vue'

export default {
  name: 'RecosPage',
  components: {
    Recos
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/pages/recos.vue